import type { OrderAttribute } from "@jti/magento";
import { Controller, TextInput, useFormContext, useTranslations } from "@jti/ui";

import { ORDER_ATTRIBUTE_FORM_FIELD_IDENTIFIER } from "@checkout-v2/features/OrderAttributes/const";
import { textInputOrderAttributesValidationRulesFactory } from "@checkout-v2/features/OrderAttributes/utils/orderAttributesValidationRulesFactory";

export type TextAttributeInputProps = { attribute: OrderAttribute };

export const TextAttributeInput = ({ attribute }: TextAttributeInputProps) => {
  const { control } = useFormContext();
  const { __ } = useTranslations();
  const validation = textInputOrderAttributesValidationRulesFactory(attribute, __);

  const name = `${ORDER_ATTRIBUTE_FORM_FIELD_IDENTIFIER}.${attribute.code}`;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={attribute?.value || ""}
      rules={validation}
      render={({ field, fieldState }) => {
        return (
          <TextInput
            id={name}
            label={attribute.label}
            placeholder={attribute.placeholder}
            data-testid={`${ORDER_ATTRIBUTE_FORM_FIELD_IDENTIFIER}-${attribute.code}`}
            isError={!!fieldState.error}
            errorText={fieldState.error?.message || ""}
            required={!!attribute.is_required}
            helperText={attribute.description}
            {...field}
          />
        );
      }}
    />
  );
};
